import { apiFetch } from '@/lib/api';
import type { UnitAudit } from '@claro/shared';

/** Fetch every server page; the API caps each response at 200 rows. */
export async function fetchAuditExportRows(filters: Record<string, string>): Promise<UnitAudit[]> {
  const rows: UnitAudit[] = [];
  for (let page = 1; ; page++) {
    const query = new URLSearchParams({ ...filters, page: String(page), limit: '200' });
    const result = await apiFetch<{data: UnitAudit[]; totalPages: number}>(`/claro/api/audit/divergences?${query}`);
    rows.push(...result.data);
    if (page >= result.totalPages || result.data.length === 0) return rows;
  }
}
